import { defineStore } from "pinia";
export const useDashboardStore = defineStore("dashboard", {
  state: () => ({
    stats: {
      totalUnits: 128,
      paidUnits: 96,
      overdueUnits: 32,
      monthlyCollected: 184500,
      monthlyTarget: 240000,
    },

    monthlyCollections: [
      { month: "ม.ค.", amount: 160000, target: 240000 },
      { month: "ก.พ.", amount: 172500, target: 240000 },
      { month: "มี.ค.", amount: 184500, target: 240000 },
      { month: "เม.ย.", amount: 0, target: 240000 },
      { month: "พ.ค.", amount: 0, target: 240000 },
      { month: "มิ.ย.", amount: 0, target: 240000 },
    ],

    recentInvoices: [
      {
        id: "INV-2026-0001",
        unitNo: "A-101",
        residentName: "สมชาย ใจดี",
        amount: 2500,
        dueDate: "2026-04-05",
        status: "paid",
      },
      {
        id: "INV-2026-0002",
        unitNo: "A-102",
        residentName: "สุดา รุ่งเรือง",
        amount: 2500,
        dueDate: "2026-04-05",
        status: "pending",
      },
      {
        id: "INV-2026-0003",
        unitNo: "B-203",
        residentName: "นที วรากร",
        amount: 3200,
        dueDate: "2026-04-05",
        status: "overdue",
      },
      {
        id: "INV-2026-0004",
        unitNo: "C-305",
        residentName: "อรทัย พงศ์พันธ์",
        amount: 2800,
        dueDate: "2026-04-05",
        status: "partial",
      },
      {
        id: "INV-2026-0005",
        unitNo: "D-110",
        residentName: "ปกรณ์ ศิริชัย",
        amount: 2500,
        dueDate: "2026-04-05",
        status: "paid",
      },
    ],

    unpaidUnits: [
      {
        unitNo: "B-203",
        residentName: "นที วรากร",
        overdueDays: 18,
        amount: 3200,
      },
      {
        unitNo: "E-402",
        residentName: "จิราพร บุญมี",
        overdueDays: 25,
        amount: 2500,
      },
      {
        unitNo: "F-208",
        residentName: "วสันต์ เกียรติยศ",
        overdueDays: 42,
        amount: 4100,
      },
      {
        unitNo: "G-109",
        residentName: "พรทิพย์ สกุลดี",
        overdueDays: 12,
        amount: 2500,
      },
      {
        unitNo: "H-501",
        residentName: "ชัยวัฒน์ ทองสุข",
        overdueDays: 67,
        amount: 5000,
      },
    ],

    quickActions: [
      {
        title: "ออกใบแจ้งหนี้",
        description: "สร้างใบแจ้งหนี้ค่าส่วนกลางรอบใหม่",
        icon: "bi-receipt",
        color: "primary",
        route: "/invoices",
      },
      {
        title: "รับชำระเงิน",
        description: "บันทึกรายการชำระจากลูกบ้าน",
        icon: "bi-cash-stack",
        color: "success",
        route: "/payments",
      },
      {
        title: "ตรวจสอบค้างชำระ",
        description: "ดูรายการลูกบ้านที่ยังค้างชำระ",
        icon: "bi-exclamation-triangle",
        color: "warning",
        route: "/arrears",
      },
      {
        title: "จัดการยูนิต",
        description: "เพิ่ม แก้ไข และดูรายละเอียดบ้าน/ห้อง",
        icon: "bi-buildings",
        color: "info",
        route: "/units",
      },
    ],
  }),

  getters: {
    collectionPercent: (state) => {
      if (!state.stats.monthlyTarget) return 0;
      return Math.round(
        (state.stats.monthlyCollected / state.stats.monthlyTarget) * 100,
      );
    },
  },
});
